import callImage from "../../images/LandingPageImage/cta_img_1x.webp";

const CTA = () => {
  return (
    <>
      <style>{`
        .cta-wrap { padding: 5rem 10rem; background:#5468eb; }
        .cta-card {
          border-radius: 20px;           
          box-shadow: 0 6px 24px rgba(0,0,0,.06);
        }
        .cta-lead { max-width: 900px; margin: 0 auto; }
        .cta-img { max-width: 85%; height: auto; display: block; }
        .cta-img-wrap { padding: 1rem 0; }

        @media (max-width: 1200px){
          .cta-wrap { padding: 4rem 4rem; }
          .cta-img { max-width: 90%; }
        }
        @media (max-width: 992px){
          .cta-wrap { padding: 3rem 2rem; }
        }
        @media (max-width: 768px){
          .cta-wrap { padding: 2rem 1.25rem; }
          .cta-img { max-width: 80%; }
        }
        @media (max-width: 576px){
          .cta-wrap { padding: 1.5rem 1rem; }
        }
      `}</style>

      <div className="d-flex justify-content-center cta-wrap bg-light-green-2">
        <div className="row col-12 bg-white border-redius-20 responsive-container cta-card m-0">
          {/* Text */}
          <div className="col-12 d-flex justify-content-center align-items-center">
            <div className="p-4 d-flex justify-content-center flex-column text-center">
              <div className="text-5-2">
                Maximize your Marketing ROI, Turn Clicks into Meaningful Connections!
              </div>
              <div className="py-2 cta-lead">
                Harness the power of WhatsApp to generate high-quality leads,
                nurture relationships, and engage with your audience effortlessly.
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CTA;
